import {Action, combineReducers, configureStore, ThunkAction} from '@reduxjs/toolkit';
import authReducer from '@commons/core.slice';
import menuReducer from '../core/menu/slice';
import envReducer from '../core/environment/slice';
import {aziendaMiddlewares, aziendaReducers} from "./reducers/azienda";
import {lavoratoriMiddlewares, lavoratoriReducers} from "./reducers/lavoratori";
import {sistemaMiddlewares, sistemaReducers} from "./reducers/sistema";
import {toolsMiddlewares, toolsReducers} from "./reducers/tools";
import {PVAMiddlewares, PVAReducers} from "./reducers/PVA";
import {serviziMiddlewares, serviziReducers} from "./reducers/servizi";

import {FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE,} from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import {CoreState} from "@commons/core.state";
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';

// N.B. non è possibile utilizzare combineReducers per realizzare una gerarchia delle chiamate API, in quanto reducerPath di createApi lavora esclusivamente dalla root dello store.
// Vedi anche:
// https://github.com/reduxjs/redux-toolkit/issues/1571
// https://github.com/reduxjs/redux-toolkit/issues/2766

// Per redux-persist:
// https://blog.logrocket.com/persist-state-redux-persist-redux-toolkit-react/
const authPersistConfig = {
    key: 'auth',
    storage,
    whitelist: ['persistData'],
    stateReconciler: autoMergeLevel2
}

// con combineReducers ho modo di creare un unico reducer da passare allo store, per ciascun albero dello store posso configurare una specifica persistenza
const reducer = combineReducers({
    menu: menuReducer,
    auth: persistReducer<CoreState>(authPersistConfig, authReducer),
    env: envReducer,
    ...aziendaReducers,
    //lavoratori:lavoratoriReducers,
    ...lavoratoriReducers,
    ...sistemaReducers,
    ...toolsReducers,
    ...PVAReducers,
    ...serviziReducers,
});

export const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            // https://www.bam.tech/article/the-redux-best-practice-do-not-put-non-serializable-values-in-state-or-actions-explained
            serializableCheck: {
                // Ignore these action types
                // da https://stackoverflow.com/questions/61704805/getting-an-error-a-non-serializable-value-was-detected-in-the-state-when-using
                // e sopratutto dalla guida ufficiale
                // https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                // Ignore these field paths in all actions
                //ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
                // Ignore these paths in the state
                //ignoredPaths: ['calendarCrud.resource.dtInizio', 'calendarCrud.resource.dtFine'],
            },
        })
            .concat(aziendaMiddlewares)
            .concat(lavoratoriMiddlewares)
            .concat(sistemaMiddlewares)
            .concat(toolsMiddlewares)
            .concat(PVAMiddlewares)
            .concat(serviziMiddlewares)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType,
    RootState,
    unknown,
    Action<string>>;

// <persistStore> è la funzione che salverà lo store nel local storage, dopo un refresh del browser, lo store sarà ripristinato allo stato precedente.
export const persistor = persistStore(store, null, () => {
    // this will be invoked after rehydration is complete
    console.log("persist store ripristinato!");
    const auth = store.getState().auth;
    console.log('contratto precedente:',auth.persistData.contratto)
});